import React from "react"
import { Plug } from "lucide-react"
import Checkbox from "../../../atoms/checkbox"
import AvatarComBadge from "../../../AvatarComBadge"
import telefoneFormatar from "../../../../utils/telefoneFormatar"
import {
  StyledContactItem,
  ContactInfoWrapper,
  ContactTextWrapper,
  ContactName,
  ContactPhone,
  ContactConnection,
} from "./ContactItemStyle"
import textoTruncar from "../../../../utils/textoTruncar"
import { canais } from "../../../../utils/canais"

export const ContactItem = ({ contato, isSelected, onSelect, multiplos }) => {
  const cTipoCanal = Object.keys(canais).find((key) => canais[key] === contato.canalTipoId)
  const cNomeConexao = contato?.conexaoNome?.trim()

  return (
    <StyledContactItem selected={isSelected} onClick={() => onSelect(contato)}>
      <ContactInfoWrapper>
        <AvatarComBadge
          cSrcPrincipal={contato?.imagemPerfil}
          cNomePrincipal={contato?.nome}
          cNomeAbreviacao={cTipoCanal === "interno" ? contato?.nomeAbreviacao : undefined}
          cTipoCanal={cTipoCanal}
          nTamanho={48}
        />
        <ContactTextWrapper>
          <ContactName>
            {textoTruncar(contato.nome, contato.empresa ? 13 : 25)}{" "}
            {contato.empresa && ` - ${textoTruncar(contato.empresa, 13)}`}
          </ContactName>
          <ContactPhone>{cTipoCanal === "interno" ? "Chat interno" : telefoneFormatar(contato)}</ContactPhone>
          {cTipoCanal !== "interno" && cNomeConexao && (
            <ContactConnection>
              <Plug size={12} strokeWidth={1.6} aria-hidden />
              {textoTruncar(cNomeConexao, 28)}
            </ContactConnection>
          )}
        </ContactTextWrapper>
      </ContactInfoWrapper>

      <Checkbox multiplos={multiplos} checked={isSelected} />
    </StyledContactItem>
  )
}
